const Footer = () => {
  return <footer>©HYUNDAI FUTURENET. ALL RIGHTS RESERVED.</footer>;
};

export default Footer;
